module.exports = __webpack_public_path__ + "static/AWS_Balloon-1682e78b0d59e72087795fb8c6e411c5.png";